import { render, staticRenderFns } from "./create_stage.vue?vue&type=template&id=36d0a772&scoped=true"
import script from "./create_stage.vue?vue&type=script&lang=js"
export * from "./create_stage.vue?vue&type=script&lang=js"
import style0 from "./create_stage.vue?vue&type=style&index=0&id=36d0a772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0a772",
  null
  
)

export default component.exports